import React, { FC } from "react";
import styled from "styled-components";

const StyledHeaderLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .HeaderLogo__badge {
    width: 28px;
    height: 28px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: bold;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.yellow};

    background: #111111;
    border-radius: 7px;
  }

  .HeaderLogo__wordmark {
    font-weight: bold;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.black};
  }
`;

const HeaderLogo: FC = () => (
  <StyledHeaderLogo>
    {/* In RTL flex: first child = right (badge at the edge), second = left */}
    <div className="HeaderLogo__badge">P</div>
    <span className="HeaderLogo__wordmark">Punct</span>
  </StyledHeaderLogo>
);

export { HeaderLogo };
